import React, { useEffect, useState } from 'react';
import AdminShell from '../components/AdminShell';
import { api } from '../lib/api';

const AdminLearners = () => {
  const [data, setData] = useState([]);
  const [curriculum, setCurriculum] = useState('');
  const [grade, setGrade] = useState('');

  const load = async () => {
    const params = new URLSearchParams();
    if (curriculum) params.append('curriculum', curriculum);
    if (grade) params.append('grade', grade);
    const r = await api.get(`/admin/learners?${params.toString()}`);
    setData(r.data.items || []);
  };
  useEffect(() => { load(); }, [curriculum, grade]);

  return (
    <AdminShell title="Learners">
      <div className="flex gap-3 mb-5" data-testid="learner-filters">
        <select value={curriculum} onChange={(e) => setCurriculum(e.target.value)} className="apc-input !w-auto" data-testid="filter-curriculum">
          <option value="">All curricula</option><option>CAPS</option><option>IEB</option>
        </select>
        <select value={grade} onChange={(e) => setGrade(e.target.value)} className="apc-input !w-auto" data-testid="filter-grade">
          <option value="">All grades</option>
          {[4,5,6,7,8,9,10,11,12].map((g) => <option key={g} value={g}>Grade {g}</option>)}
        </select>
      </div>
      <div className="bg-white rounded-2xl border border-black/5 overflow-x-auto" data-testid="learners-table">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F5F2] text-left">
            <tr>
              <th className="px-4 py-3 font-semibold text-[#1B2A41]">Learner</th>
              <th className="px-4 py-3 font-semibold text-[#1B2A41]">Curriculum</th>
              <th className="px-4 py-3 font-semibold text-[#1B2A41]">Grade</th>
              <th className="px-4 py-3 font-semibold text-[#1B2A41]">Status</th>
              <th className="px-4 py-3 font-semibold text-[#1B2A41]">Google</th>
            </tr>
          </thead>
          <tbody>
            {data.map((l) => (
              <tr key={l.id} className="border-t border-black/5" data-testid={`learner-row-${l.id}`}>
                <td className="px-4 py-3">{l.full_name}</td>
                <td className="px-4 py-3">{l.latest_enrolment?.curriculum || '—'}</td>
                <td className="px-4 py-3">{l.latest_enrolment ? `Grade ${l.latest_enrolment.grade}` : '—'}</td>
                <td className="px-4 py-3"><span className="text-xs font-semibold px-2 py-1 rounded-full bg-[#F3F5F2]">{l.latest_enrolment?.status || '—'}</span></td>
                <td className="px-4 py-3 text-[#4B5563]">{l.google_email}</td>
              </tr>
            ))}
            {!data.length && <tr><td colSpan={5} className="px-4 py-8 text-center text-[#4B5563]">No learners yet.</td></tr>}
          </tbody>
        </table>
      </div>
      <style>{`.apc-input { padding:0.6rem 0.9rem; border-radius:10px; border:1px solid rgba(27,42,65,0.15); background:#fff; font-size:0.9rem; }`}</style>
    </AdminShell>
  );
};

export default AdminLearners;
